import MenuDocumentSearch from "./MenuDocumentSearch";

export default MenuDocumentSearch;
